export function elfproef(bsn: string) {
    if (bsn.length < 8 || bsn.length > 9) {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < bsn.length; i++) {
        sum = sum + parseInt(bsn[i], 10) * (i === bsn.length - 1 ? -1 : bsn.length - i);
    }

    return sum % 11 === 0;
}
